import React, { useState, useRef, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import "./PayoutModal.scss";
import { AlertMessage } from "../common";

function PayoutModal(props) {
  const modalRef = useRef(null);
  const [notify, setnotify] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [transfer, setTransfer] = useState({
    amount: 0,
    grossAmount: 0,
    taxPercentage: props.taxPercentage,
    taxPercentageAmount: 0,
    processingFee: props.processingFee,
    netAmount: 0,
    password: "",
    loading: false,
  });
  const encashmentTypes = ["ATM_Encashment", "Check_Encashment"],
    releaseMethod = ["Shipout"];
  const [encashmentRequest, setEncashmentRequest] = useState({
    type: "ATM_Encashment",
    amount: 0,
    grossAmount: 0,
    taxPercentage: props.taxPercentage,
    taxPercentageAmount: 0,
    processingFee: props.processingFee,
    netAmount: 0,
    password: "",
    loading: false,
    releaseMethod: "ShipOut",
    address: "",
    country: "",
    province: "",
    city: "",
    barangay: "",
    street: "",
    zipcode: "",
    accountNumber: "",
  });

  const encashmentonChange = (e) => {
    setEncashmentRequest((prevRequest) => ({
      ...prevRequest,
      [e.target.name]: e.target.value,
    }));
  };
  const transferOnChange = (e) => {
    console.log(e.target.name, "name changes");
    if (e.target.name === "amount") {
      const amount = Number(e.target.value);
      const taxPercentage = parseFloat(transfer.taxPercentage);
      const taxPercentageAmount = (amount * taxPercentage) / 100;
      setTransfer((prevState) => ({
        ...prevState,
        amount,
        grossAmount: amount,
        taxPercentageAmount,
        netAmount:
          amount - Number(taxPercentageAmount + transfer.processingFee),
      }));
    } else {
      setTransfer((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };
  const notifyDissmissed = () => {
    setnotify((prev) => ({
      ...prev,
      show: false,
    }));
  };

  const CloseIcon = () => (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  );

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        console.log("Closing modal");
        props.onClose();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [props.onClose]);

  const transactionWalletSubmit = async () => {
    setTransfer((prevState) => ({
      ...prevState,
      loading: true,
    }));
    try {
      const errorMessage =
        transfer.amount <= 0
          ? "Amount must be valid"
          : transfer.netAmount <= 0
          ? "Net amount should be valid"
          : transfer.password === ""
          ? "Password cannot be empty"
          : "";

      if (errorMessage) {
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message: errorMessage,
        }));
        setTransfer((prevState) => ({
          ...prevState,
          loading: false,
        }));
        return;
      } else {
        setTransfer((prevState) => ({
          ...prevState,
          amount: 0,
          grossAmount: 0,
          taxPercentage: props.taxPercentage,
          taxPercentageAmount: 0,
          processingFee: props.processingFee,
          netAmount: 0,
          password: "",
          loading: false,
        }));
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "success",
          message: "Encashment Completed Successfully.",
        }));
      }
    } catch (error) {
      setTransfer((prevState) => ({
        ...prevState,
        loading: false,
      }));
      console.log(error);
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Some Error Occured...!",
      }));
    }
  };
  return (
    <div className="modall-wrapper">
      <div className="modall" ref={modalRef}>
        <button className="close-button" onClick={props.onClose}>
          <CloseIcon />
        </button>
        <div className="modall-content" style={{ overflowY: " " }}>
          {props.item.id === 1 && (
            <div className="modals">
              <div className="bordergreen"></div>
              <div className="headlabel">Encashment - Transfer to Wallet</div>
              <div style={{ fontSize: "10px" }}>
                Please enter below details{" "}
              </div>
              <br />
              <br />
              <Form.Group controlId="formCardNo">
                <Form.Label>Amount *</Form.Label>
                <Form.Control
                  type="text"
                  name="amount"
                  placeholder=""
                  value={transfer.amount}
                  onChange={transferOnChange}
                />
              </Form.Group>
              <hr className="hr-custom" />
              <div className="headlabel">Review Encashment Details</div>
              <Form.Label>Gross Amount:</Form.Label>
              <Form.Control type="text" value={transfer.grossAmount} readOnly />
              <Form.Label>TAX: ({`${transfer.taxPercentage}%`}):</Form.Label>
              <Form.Control
                type="text"
                value={transfer.taxPercentageAmount}
                readOnly
              />
              <Form.Label>Processing Fee:</Form.Label>
              <Form.Control
                type="text"
                value={transfer.processingFee}
                readOnly
              />
              <Form.Label>Net Amount:</Form.Label>
              <Form.Control type="text" value={transfer.netAmount} readOnly />
              <hr className="hr-custom" />
              <Form.Group controlId="formPassword">
                <Form.Label>Enter Password</Form.Label>
                <Form.Control
                  placeholder="********"
                  type="password"
                  name="password"
                  value={transfer.password}
                  onChange={transferOnChange}
                />
              </Form.Group>
              <br />
              <Button
                style={{
                  fontSize: "14px",
                  borderRadius: "2px",
                  height: "32px",
                  width: "170px",
                }}
                variant="success"
                onClick={transactionWalletSubmit}
                disabled={transfer.loading}
              >
                <strong>
                  {transfer.loading ? "Loading" : "Process Encashment"}
                </strong>
              </Button>
            </div>
          )}
          {props.item.id === 2 && (
            <div className="modals">
              <div className="bordergreen"></div>
              <div className="headlabel">{props.item.label}</div>
              <div style={{ fontSize: "10px" }}>
                Please enter the following details:
              </div>
              <br />
              <br />
              <div className="id-two">
                <Form.Group controlId="formCategory">
                  <Form.Label for="category">Category</Form.Label>
                  <Form.Control
                    id="category"
                    name="category"
                    placeholder="JORDAN GC (3000 PTS)"
                    type="text"
                    as="select"
                    value=""
                    onChange=""
                    className="form-control"
                    style={{ width: "289px" }}
                  >
                    <option></option>
                    <option>JORDAN GC (4000 PTS)</option>
                    <option>JORDAN GC (5000 PTS)</option>
                    <option>JORDAN GC (6000 PTS)</option>
                  </Form.Control>
                </Form.Group>
                <br />
                <Form.Group
                  style={{ marginTop: "-27px" }}
                  controlId="formQuantity"
                >
                  <Form.Label>Quantity</Form.Label>
                  <Form.Control
                    placeholder="quantity"
                    type="text"
                    value=""
                    onChange=""
                    className="form-control"
                  />
                </Form.Group>
                <Form.Group controlId="formPoints">
                  <Form.Label>Total ePoints</Form.Label>
                  <Form.Control
                    placeholder="Total ePoints"
                    type="text"
                    value=""
                    onChange=""
                    className="form-control"
                  />
                </Form.Group>
                <Form.Group controlId="formAmount">
                  <Form.Label>Amount</Form.Label>
                  <Form.Control
                    placeholder="Amount"
                    type="text"
                    value=""
                    className="form-control"
                  />
                </Form.Group>
                <br />
                <Form.Group
                  style={{ marginTop: "-27px" }}
                  controlId="formPassword"
                >
                  <Form.Label>Enter Password</Form.Label>
                  <Form.Control
                    placeholder="********"
                    type="password"
                    value=""
                    className="form-control"
                  />
                </Form.Group>
                {/* <br /> */}
              </div>
              <Button
                style={{
                  fontSize: "10px",
                  borderRadius: "2px",
                  height: "27px",
                  width: "170px",
                }}
                variant="success"
                onClick=""
                className="btn btn-success"
              >
                <strong>Submit</strong>
              </Button>
            </div>
          )}
          {props.item.id === 3 && (
            <div className="modals">
              <div className="bordergreen"></div>
              <div className="headlabel">{props.item.label}</div>
              <div style={{ fontSize: "10px" }}>
                Please enter the following details:
              </div>
              <br />
              <br />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="row">
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        placeholder="Amount"
                        type="text"
                        value=""
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-6">
                    <Form.Group controlId="formCategory">
                      <Form.Label for="type">Type</Form.Label>
                      <Form.Control
                        id="type"
                        name="type"
                        type="text"
                        as="select"
                        value={encashmentRequest.type}
                        onChange={encashmentonChange}
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                      >
                        <option>Select Encashment Type</option>
                        {encashmentTypes.map((type) => {
                          return;
                          <option>{type}</option>;
                        })}
                      </Form.Control>
                    </Form.Group>
                  </div>
                  {encashmentRequest.type == "ATM_Encashment" && (
                    <>
                      <div className="col-6">
                        <Form.Group controlId="formCategory">
                          <Form.Label for="type">Bank Details:</Form.Label>
                          <Form.Control
                            id="type"
                            name="type"
                            type="text"
                            as="select"
                            value=""
                            onChange=""
                            className="form-control"
                            style={{
                              height: "30px",
                              // maxWidth: "10rem",
                              // minWidth: "10rem",
                            }}
                          >
                            <option></option>
                            <option>BDO</option>
                          </Form.Control>
                        </Form.Group>
                      </div>
                      <div className="col-6">
                        <Form.Group controlId="formAmount">
                          <Form.Label>Account Number:</Form.Label>
                          <Form.Control
                            placeholder="Account Number"
                            type="text"
                            name="accountNumber"
                            value={encashmentRequest.accountNumber}
                            className="form-control"
                            style={{
                              height: "30px",
                              // maxWidth: "10rem",
                              // minWidth: "10rem",
                            }}
                          />
                        </Form.Group>
                      </div>
                    </>
                  )}
                </div>
                <div className="headlabel">Review Encashment Details</div>
                <br />
                <br />
                <div className="row">
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Gross Amount:</Form.Label>
                      <Form.Control
                        placeholder="Amount"
                        type="text"
                        value=""
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                        readOnly
                      />
                    </Form.Group>
                  </div>
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>W/ TAX (10%)</Form.Label>
                      <Form.Control
                        placeholder="Amount"
                        type="text"
                        value=""
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                        readOnly
                      />
                    </Form.Group>
                  </div>
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Processing Fee:</Form.Label>
                      <Form.Control
                        placeholder="Amount"
                        type="text"
                        value=""
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                        readOnly
                      />
                    </Form.Group>
                  </div>
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Net Amount:</Form.Label>
                      <Form.Control
                        placeholder="Amount"
                        type="text"
                        value=""
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                        readOnly
                      />
                    </Form.Group>
                  </div>
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Release Method:</Form.Label>
                      <Form.Control
                        id="type"
                        name="releaseMethod"
                        type="text"
                        as="select"
                        value={encashmentRequest.releaseMethod}
                        onChange={encashmentonChange}
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                      >
                        <option>Select Release Method </option>
                        {releaseMethod.map((type) => {
                          return;
                          <option>{type}</option>;
                        })}
                      </Form.Control>
                    </Form.Group>
                  </div>
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Address:</Form.Label>
                      <Form.Control
                        id="type"
                        name="releaseMethod"
                        type="text"
                        as="select"
                        value={encashmentRequest.releaseMethod}
                        onChange={encashmentonChange}
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                      >
                        <option>Select Release Method </option>
                        {releaseMethod.map((type) => {
                          return;
                          <option>{type}</option>;
                        })}
                      </Form.Control>
                    </Form.Group>
                  </div>
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Country *</Form.Label>
                      <Form.Control
                        id="type"
                        name="releaseMethod"
                        type="text"
                        as="select"
                        value={encashmentRequest.releaseMethod}
                        onChange={encashmentonChange}
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                      >
                        <option>Select Release Method </option>
                        {releaseMethod.map((type) => {
                          return;
                          <option>{type}</option>;
                        })}
                      </Form.Control>
                    </Form.Group>
                  </div>
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Province *</Form.Label>
                      <Form.Control
                        id="type"
                        name="releaseMethod"
                        type="text"
                        as="select"
                        value={encashmentRequest.releaseMethod}
                        onChange={encashmentonChange}
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                      >
                        <option>Select Release Method </option>
                        {releaseMethod.map((type) => {
                          return;
                          <option>{type}</option>;
                        })}
                      </Form.Control>
                    </Form.Group>
                  </div>
                  {/*4th  */}
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>City *</Form.Label>
                      <Form.Control
                        id="type"
                        name="releaseMethod"
                        type="text"
                        as="select"
                        value={encashmentRequest.releaseMethod}
                        onChange={encashmentonChange}
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                      >
                        <option>Select Release Method </option>
                        {releaseMethod.map((type) => {
                          return;
                          <option>{type}</option>;
                        })}
                      </Form.Control>
                    </Form.Group>
                  </div>
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Barangay</Form.Label>
                      <Form.Control
                        id="type"
                        name="releaseMethod"
                        type="text"
                        as="select"
                        value={encashmentRequest.releaseMethod}
                        onChange={encashmentonChange}
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                      >
                        <option>Select Release Method </option>
                        {releaseMethod.map((type) => {
                          return;
                          <option>{type}</option>;
                        })}
                      </Form.Control>
                    </Form.Group>
                  </div>
                  {/* 5th */}
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Street/Building Name*</Form.Label>
                      <Form.Control
                        placeholder="Amount"
                        type="text"
                        value=""
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Zip Code</Form.Label>
                      <Form.Control
                        placeholder="Amount"
                        type="text"
                        value=""
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                      />
                    </Form.Group>
                  </div>
                  <br />
                  <div className="col-6">
                    <Form.Group controlId="formAmount">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        placeholder="Password"
                        type="password"
                        value=""
                        className="form-control"
                        style={{
                          height: "30px",
                          // maxWidth: "10rem",
                          // minWidth: "10rem",
                        }}
                      />
                    </Form.Group>
                  </div>
                </div>
                <Button
                  style={{
                    fontSize: "10px",
                    borderRadius: "2px",
                    height: "27px",
                    width: "170px",
                  }}
                  variant="success"
                  onClick=""
                  className="btn btn-success"
                >
                  <strong>Process Encashment</strong>
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      {notify.show && (
        <div>
          <AlertMessage
            message={notify.message}
            dismiss={notifyDissmissed}
            type={notify.type}
            header={notify.header}
            show={notify.show}
          />
        </div>
      )}
    </div>
  );
}

export default PayoutModal;
